export function areAllChartsLoaded(handle, setAllChartsLoaded) {
    const charts = document.querySelectorAll('.recharts-wrapper');
    const chartsArray = Array.prototype.slice.call(charts);
    const allLoaded = chartsArray.every((chart) => chart.clientWidth !== 0);

    if (allLoaded) {
        clearInterval(handle);
        setAllChartsLoaded(true);
    }
}

export function createCanvas() {
    const canvas = document.createElement('canvas');
    canvas.id = 'canvas';
    canvas.style.display = 'none';
    document.body.appendChild(canvas);
}

export function addPrintOrientationStyles(landscape) {
    const styles = landscape
        ? '@page { size: A4 landscape; margin: 0; }'
        : '@page { size: A4 portrait; margin: 0; }';

    const printOrientationStyles = document.createElement('style');

    if (printOrientationStyles.styleSheet)
        printOrientationStyles.styleSheet.cssText = styles;
    else printOrientationStyles.appendChild(document.createTextNode(styles));

    document.querySelector('head').appendChild(printOrientationStyles);
}

export function getDataFromLocalStorage(key) {
    try {
        const storedInfo = localStorage.getItem(key);
        const info = JSON.parse(storedInfo);
        return info;
    } catch (error) {
        throw new Error(`Local storage data not well formatted: ${key}`);
    }
}

export function removeWebClientHeader() {
    const possibleHeaders = document.querySelectorAll(
        '.web-client-header, .smartsuite-menu'
    );
    possibleHeaders.forEach((header) => {
        // eslint-disable-next-line no-param-reassign
        header.style.display = 'none';
    });
}
